import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { APPLICANT_STATUS } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomValidator } from '../Helper/custom-validator';
import { PricePlanService } from '../Price-subscritions/priceplanService';
import { MessageWidgetComponent } from '../../widget/message-widget/message-widget.component';
import { TruncatePipe } from '../../pipe/TruncatePipe.pipe';
import { TimezoneDatePipe } from '../../timezone-date.pipe';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { ContractCandidateService } from 'src/app/services/contract-candidate.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CompactCountPipe } from '../../pipe/compact-count.pipe';
import { isEyeIconMenu } from 'src/app/services/eye-icon-menu';

declare var $: any
@Component({
  selector: "app-candidate-job-details",
  standalone: true,
  imports: [
    CompactCountPipe,
    BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule,
MessageWidgetComponent, TruncatePipe, TimezoneDatePipe,DndDirective,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./candidate-job-details.component.html",
  styleUrls: ["./candidate-job-details.component.scss"],
})
export class CandidateJobDetailsComponent
  extends FormValidation
  implements OnInit, OnChanges {
  @Input() interactionResponse: Array<any>;
  @Input() showInteractiveButton: boolean = false;
  @Input() contentType: "CDI" | "JA" = "CDI";
  @Input() cardContent: string = "DEFAULT";
  @Input() totalCount: any;
  @Input() page: any;
  // When true, the chat button opens the conversation directly and SKIPS the
  // ACTIVE_INTERACTIONS gate (findUserPlanBenefits + findPlans). Set by menus
  // where the interaction is already consumed by a prior action — My Jobs →
  // Resume Request (resume-request-sent) and Candidate Invited (candidate-invite) —
  // so re-checking / blocking credits on the chat click is not needed.
  @Input() skipInteractionGate: boolean = false;
  downloadurl = AppSettings.photoUrl;
  userId = localStorage.getItem("userId");
  userType = localStorage.getItem("userType");
  messagemodelflag: boolean;
  messageData: any[];
  seletedChatItem: any;
  rtrformgrp: UntypedFormGroup;
  // fileDragdrop: any;
  resumeupload: any;
  fileSize: any;
  tempFile: any;
  modalRef: BsModalRef;
  statusCall: string;
  FormData: FormData;
  tempstatus: any;
  tempdata: any;
  submitRTR: boolean;
  obj: any = {
    limit: 10,
    pageNumber: 0,
    userId: localStorage.getItem("userId"),
  };
  showResumeUpload: boolean;
  pendingOfferedData: any;
  pendingOfferedCandidate: any;
  b2bData: any;
  rtrModalRef: BsModalRef;
  nextPage = new EventEmitter();
  resumeIndex: any;
  resumeuploaduserId: any;
  candidateId: any;
  jobId: any;
   expandedSkills: Set<string> = new Set();
  Resurl = AppSettings.ServerUrl;
  constructor(
    private arouter: ActivatedRoute,
    private auth: ApiService,
    private router: Router,
    private JobServicecolor: JobService,
    private util: UtilService,
    private api: ApiService,
    private formbuilder: UntypedFormBuilder,
    private modalService: BsModalService,
    private pricePlan: PricePlanService,
    private cdr: ChangeDetectorRef,
    private contractCandidateService: ContractCandidateService
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.interactionResponse != undefined) {
      this.interactionResponse = changes.interactionResponse.currentValue;
    }
  }

  ngOnInit() {
    let data: string =
      (
        (this.contentType === "CDI" && this.cardContent === "DEFAULT") ? "JOB_APPLICATION_BUYER_ACTIONS" :
          (this.contentType === "CDI" && this.cardContent === "INVITE") ? "JOB_INVITATION_SUPPLIER_ACTIONS" :
            (this.contentType === "JA" && this.cardContent === "DEFAULT") ? "JOB_INVITATION_SUPPLIER_ACTIONS" :
              "JOB_APPLICATION_SUPPLIER_ACTIONS"
      );

    data = data + (data.includes("APPLICATION") ? ",JOB_APPLICATION_BLOCKING_ACTIONS" : ",JOB_INVITATION_BLOCKED_ACTIONS");

    this.getApplicantFilter(data);


    // Locked 2026-06-08 — two-row payrate model (parity with candidate-card).
    this.rtrformgrp = this.formbuilder.group({
      submittedToRate: [{ value: null, disabled: true }],
      submittedRateType: [{ value: null, disabled: true }],
      offerRate: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace(),
        ]),
      ],
      offerRateType: [null, Validators.required],
      country: null,
      termsandcondition: [null, Validators.requiredTrue],
    });
  }


  getApplicantFilter(data: string) {
    this.auth.create(`listvalue/findbyList`, { domain: data }).subscribe((res) => {
      if (res.code === GigsumoConstants.SUCESSCODE) {
        let d = data.split(",");
        if (res.data[d[0]]) {
          this.jobApplicationFilter = res.data[d[0]].listItems;
          this.jobApplicationFilter.forEach(d => d.wait = false);
          this.jobApplicationBlockedStatus = res.data[d[1]] && res.data[d[1]].listItems;
        }
      }
    });
  }

  getCountryValue(code: string) {
    switch (code) {
      case "US":
        return "USD /";
      case "IN":
        return "INR /";
      case "CA":
        return "CAD /";
      case "AU":
        return "AUD /";
      default:
        return "CUR /";
        break;
    }
  }

  getPaytype(code: string) {
    switch (code) {
      case "Hourly":
        return "Hr";
      case "Daily":
        return "Day";
      case "Weekly":
        return "Week";
      case "Monthly":
        return "Month";
      case "Yearly":
        return "Year";
      default:
        break;
    }
  }

  showDropdown(index: number) {
    const dropDown: HTMLDivElement = document.getElementById(
      `dropDown${index}`
    ) as HTMLDivElement;

    if (dropDown.classList.contains("open")) {
      dropDown.classList.remove("open");
    } else {
      dropDown.classList.add("open");
    }

    this.interactionResponse.forEach((ele, i) => {
      if (i != index)
        document.getElementById(`dropDown${i}`).classList.remove("open");
    });
  }

  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }

  isExcludedStatusTwo(status: APPLICANT_STATUS): boolean {
    const find = this.jobApplicationBlockedStatus && this.jobApplicationBlockedStatus.find(x => x.itemId === status);
    return find ? true : false;
  }



  updatestatuswithdraw(datas, value) {
    this.util.startLoader();
    var data: any = {};
    data.jobId = value.jobDetails.jobId;
    data.candidateId = value.candidateEntity.candidateId;
    data.currentStatus = datas.itemId;
    value.currentStatus = datas.itemId;
    data.candidateName =
      value.candidateEntity.firstName + " " + value.candidateEntity.lastName;
    data.jobTitle = value.jobDetails.jobTitle;
    data.createdByUserName = value.jobDetailspostedByUserName;
    data.organisationName = localStorage.getItem("currentOrganization");
    data.email = value.user.username;
    this.api.create("candidates/updatejobAppliedStatus", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code === "00000") {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Status successfully Updated.",
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (res.code === "99998") {
          Swal.fire({
            position: "center",
            icon: "info",
            title: "Job application status updated already..!",
            showConfirmButton: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
          });
        }
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }
  getTitleCase(value: string): string {
    if (!value) return value;
    return value.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  isClicked: boolean = false;
  async downloadResume(data, userId, FileId, FileName?: string) {
    if (this.isClicked) {
      return;
    }

    this.isClicked = true;
    const { candidateId, createdBy, resumeDownloaded, connectionStatus, user, ...rest } = data;
    // Always run the strip helper first — the template typically passes
    // the backend's UUID-prefixed `resume.fileName`, and the previous
    // `FileName || resolve…` order let that raw value through and the
    // saved file kept the `<uuid>_` prefix. Resolve from `data.resumes`
    // first (always stripped), fall back to the passed-in name.
    const resolvedFileName = this.resolveResumeFileName(data, FileId) || FileName || '';

    try {
      if (!resumeDownloaded && createdBy != this.userId && this.userType != "JOB_SEEKER") {
        const userData = await this.pricePlan.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");

        let { membershipType } = userData;
        let availablePoints = null;
        let actualPoints = null;
        let utilizedPoints = null;
        let promotional = null;

        if (userData.userDetail && userData.userDetail.userPlanAndBenefits && userData.userDetail.userPlanAndBenefits.benefitsUsages) {
          userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
            if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
              availablePoints = ele.available
              actualPoints = ele.actual
              utilizedPoints = ele.utilized
              promotional = ele.promotional
            }
          });
        }
        //showing plan popups based on the type by monisha
        if (userData.isExpired) {
          let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

          if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
            popupType = "LIMIT";
          }
          this.pricePlan.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
          // Eye-icon menu only (see isEyeIconMenu): release the lock BEFORE leaving.
          // This return skipped the 5-second release timer at the end of the method,
          // so with no slots left isClicked stayed true for good: the popup appeared
          // once and every later Download Resume click hit the guard at the top and
          // did nothing until a reload. Other screens are deliberately left as they were.
          if (isEyeIconMenu(this.router)) {
            this.isClicked = false;
          }
          return;
        } else {
          this.afterPlanValidationDownloadResume(candidateId, userId, createdBy, FileId, resolvedFileName);
        }
      } else if (resumeDownloaded || createdBy === this.userId) {
        this.afterPlanValidationDownloadResume(candidateId, userId, createdBy, FileId, resolvedFileName);
      }
    } catch (error) {
      console.error('Error in downloadResume:', error);

    }
    setTimeout(() => {
      this.isClicked = false;
    }, 5000);
  }

  /** Pull the resume's original disk name out of `data.resumes` and strip the
   *  `<uuid>_` prefix the backend prepends; the saved download needs the
   *  original extension or the OS opens it as plain text. */
  private resolveResumeFileName(data: any, fileId: any): string {
    const list = Array.isArray(data?.resumes) ? data.resumes : [];
    const match = list.find((r: any) => r?.fileId === fileId) || list[0];
    const raw = ((match?.fileName ?? match?.name) || '').toString().trim();
    if (!raw) return '';
    const uuidPrefix = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}_/;
    return uuidPrefix.test(raw) ? raw.replace(uuidPrefix, '').trim() : raw;
  }

  afterPlanValidationDownloadResume(candidateId: any, userId: any, createdBy: any, FileId: any, fileName?: string) {
    const endpoint = `candidates/resumeDownload/${candidateId}/${userId}/${createdBy}/${FileId}`;
    this.api.queryBlob(endpoint).subscribe(res => {
      const blob = new Blob([res]);
      this.downloadFile(blob, fileName || 'resume.pdf');
    });
  }

  getData(object: any, property: string) {
    if (property === "currentStatus") {
      return object[property];
    }

    if (this.contentType === "CDI" && object.candidateEntity) {
      if (property === "EXP") {
        return `Experience : ${object.candidateEntity["totalExperience"]} years`;
      } else if (property === "secondRow") {
        return object.candidateEntity["jobTitle"];
      } else if (property === "firstRow") {

        const firstName = this.getTitleCase(object.candidateEntity["firstName"]);
        const lastName = this.getTitleCase(object.candidateEntity["lastName"]);
        return `${firstName} ${lastName}`;
      } else if (property === "status") {
        return `${object.candidateEntity["status"]}`;
      }
      else if (property === 'availability') {
        return object.candidateEntity.availability;
      }

      return object.candidateEntity[property];
    }
    else if (this.contentType === "JA" && object.jobDetails) {
      if (property === 'EXP') {
        return `Experience : ${object.jobDetails && object.jobDetails['experienceFrom']} to ${object.jobDetails && object.jobDetails['experienceTo']} years`;
      } else if (property === 'secondRow') {
        return `${object.jobDetails && object.jobDetails['city']} , ${object.jobDetails && object.jobDetails['state']}`;
      } else if (property === 'firstRow') {
        return object.jobDetails ? object.jobDetails['jobTitle'] : null;
      } else if (property === 'status') {
        return object.jobDetails && object.jobDetails['status'] ? `${object.jobDetails['status']}` : null;
      } else if (property === 'availability') {
        return object.jobDetails.availability;
      }

      return object.jobDetails ? object.jobDetails[property] : null;
    }
  }

  getInitials(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }

  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  onImageError(data: any): void {
    if (data?.user) {
      data.user.photoFailed = true;
      this.cdr.detectChanges();
    }
  }

  isValidPhoto(data: any): boolean {
    return data?.user?.photo && !data?.user?.photoFailed;
  }

  getPhotoUrl(photo: string): string {
    if (!photo) return '';
    // If photo already starts with http, return as-is
    if (photo.startsWith('http')) return photo;
    // Otherwise, prepend the base photo URL
    return this.downloadurl + photo;
  }

  route(data: any, item: any, redirectPage?: string) {
    if (data != undefined) {
      const {
        jobDetails: { jobId,
          viewedByCount: jobViewedByCount,
          likesCount: jobLikesCount,
          appliedCount: jobAppliedCount,
          interestShownCount: jobInterestShownCount,
          status: jobstatus,
          availability: jobavailability,
        },
        candidateEntity: {
          candidateId,
          viewedByCount: candidateViewedByCount,
          jobsAppliedCount: jobsAppliedCount,
          likesCount: candidateLikesCount,
          interestShownCount: candidateInterestShownCount,
          status: candidatestatus,
          availability: candidateavailability,
        }
      } = data;


      if (this.contentType === "CDI" && jobstatus != 'ON HOLD' && jobavailability && candidatestatus != 'ON HOLD' && candidateavailability) {

        if (item === "views" && jobViewedByCount > 0) {
          this.router.navigate(["newjobs"], {
            queryParams: { jobId: jobId, tabName: "jobs-viewed" },
          });
        } else if (item === "likes" && jobLikesCount > 0) {
          this.router.navigate(["newjobs"], {
            queryParams: { jobId: jobId, tabName: "jobs-liked" },
          });
        } else if (
          (item === "applied" && jobAppliedCount > 0) ||
          (item === "applied" && redirectPage === "directRoute")
        ) {
          this.router.navigate(["newjobs"], {
            queryParams: {
              jobId: jobId,
              candidateId: candidateId,
              tabName: "job-applicants",
            },
          });
        } else if (
          (item === "invited" && jobInterestShownCount > 0) ||
          (item === "invited" && redirectPage === "directRoute")
        ) {
          this.router.navigate(["newjobs"], {
            queryParams: {
              jobId: jobId,
              candidateId: candidateId,
              tabName: "candidates-invited",
            },
          });
        } else if (item === "candidate-requests-received") {
          this.router.navigate(["newcandidates"], {
            queryParams: {
              candidateId: candidateId,
              tabName: "candidate-requests-received",
            },
          });
        }
        else if (item === "likes" && jobLikesCount > 0) {
          this.router.navigate(['newjobs'], { queryParams: { jobId: jobId, tabName: 'jobs-liked' } });
        }
        else if (item === "applied" && jobAppliedCount > 0 || item === "applied" && redirectPage === 'directRoute') {
          this.router.navigate(['newjobs'], { queryParams: { jobId: jobId, candidateId: candidateId, tabName: 'job-applicants' } });
        }
        else if (item === "invited" && jobInterestShownCount > 0 || item === "invited" && redirectPage === 'directRoute') {
          this.router.navigate(['newjobs'], { queryParams: { jobId: jobId, candidateId: candidateId, tabName: 'candidates-invited' } });
        }
        else if (item === "candidate-requests-received") {
          this.router.navigate(['newcandidates'], { queryParams: { candidateId: candidateId, tabName: 'candidate-requests-received' } });
        }

      }
      else if (this.contentType === "JA" && jobstatus != 'ON HOLD' && jobavailability && candidatestatus != 'ON HOLD' && candidateavailability) {

        if (item === "views" && candidateViewedByCount > 0) {
          this.router.navigate(["newcandidates"], {
            queryParams: { candidateId: candidateId, tabName: "views" },
          });
        } else if (item === "likes" && candidateLikesCount > 0) {
          this.router.navigate(["newcandidates"], {
            queryParams: { candidateId: candidateId, tabName: "Clike-like" },
          });
        } else if (
          (item === "applied" && jobsAppliedCount > 0) ||
          (item === "applied" && redirectPage === "directRoute")
        ) {
          this.router.navigate(["newcandidates"], {
            queryParams: {
              candidateId: candidateId,
              jobId: jobId,
              tabName: "jobsApplied",
            },
          });
        } else if (
          (item === "invited" && candidateInterestShownCount > 0) ||
          (item === "invited" && redirectPage === "directRoute")
        ) {
          this.router.navigate(["newcandidates"], {
            queryParams: {
              candidateId: candidateId,
              jobId: jobId,
              tabName: "cInvited",
            },
          });
        } else if (item === "candidate-requests-received") {
          this.router.navigate(["newcandidates"], {
            queryParams: {
              candidateId: candidateId,
              tabName: "candidate-requests-received",
            },
          });
        }
      }
    }
  }

  likes(data, content: string) {
    if (data.isProcessingLike) return;

    if (content == "job" && data.jobPostedBy != localStorage.getItem("userId") || content == "candidate" && data.createdBy != localStorage.getItem("userId")) {
      let datas: any = {};
      datas.userId = localStorage.getItem("userId");
      const likeStatus = data.isLiked === true ? "UNLIKE" : "LIKE";

      content === "job"
        ? (datas.jobId = data.jobId)
        : (datas.candidateId = data.candidateId);
      data.isProcessingLike = true;
      this.util.startLoader();
      datas.likeStatus = likeStatus;
      this.api
        .updatePut(
          content === "job"
            ? "jobs/updateJobLiked"
            : "candidates/updateCandidateLiked",
          datas
        )
        .subscribe(
          (res) => {
            if (res.code == "00000") {
              if (content === "job") {
                data.likesCount = res.data.jobData.likesCount;
                data.isLiked = res.data.jobData.isLiked;
              } else {
                data.isLiked = res.data.candidateData.isLiked;
                data.likesCount = res.data.candidateData.likesCount;
              }
            }
            data.isProcessingLike = false;
            this.util.stopLoader();
          },
          (err) => {
            data.isProcessingLike = false;
            this.util.stopLoader();
          }
        );
    } else {
      this.route(data, 'likes')
    }
  }

  getClientType(value: string) {
    switch (value) {
      case "Vendor":
        return "V";
        break;
      case "Direct Hire":
        return "DH";
        break;
      case "Systems Integrator":
        return "SI";
        break;
      case "Prime Vendor":
        return "PV";
        break;
      case "Recruitment Process Outsourcer":
        return "RPO";
        break;
      case "Staffing Agency":
        return "SA";
        break;
      case "Direct Client":
        return "C";
        break;
      default:
        break;
    }
  }

  isExcludedStatus(status: APPLICANT_STATUS): boolean {

    const find = this.jobApplicationBlockedStatus && this.jobApplicationBlockedStatus.find(x => x.itemId === status);
    return find ? true : false;
  }

  jobApplicationFilter: Array<any> = [];
  jobApplicationBlockedStatus: Array<any> = [];

  /**
   * Applicant-page lock for Pre-Onboarded / Onboarded — onboarding is owned by
   * the Contract Manager page, so these two stay listed in the status dropdown
   * but are greyed out and non-clickable for every viewer, at every stage.
   * See GigsumoConstants.isContractManagedApplicantStatus().
   */
  isStatusLocked(statusData: any): boolean {
    const itemId = typeof statusData === 'string' ? statusData : statusData?.itemId;
    return GigsumoConstants.isContractManagedApplicantStatus(itemId);
  }

  /**
   * "Reject Interview" (INTERVIEW-REJECTED) is the CANDIDATE OWNER's reply to an
   * interview invite — granted only by DIRECT_APPLY_CANDIDATE_NEXT in
   * CandidateService.java, and absent from the buyer ladder DIRECT_APPLY_OWNER_NEXT.
   * It must never render on the buyer-side Applicants menu.
   *
   * Hidden in the UI only — the backend transition is untouched, so the API and every
   * other surface still accept it. Applied in the CDI branch of filterApplicant() only;
   * the JA (candidate-owner) branch keeps the option.
   *
   * NOT the same as INTERVIEW-FAILED ("Interview Reject"), the post-interview rejection
   * listed below L3, which stays.
   */
  private static readonly INTERVIEW_REJECTED_ID = 'INTERVIEW-REJECTED';

  private withoutInterviewRejected(list: Array<any>): Array<any> {
    if (!Array.isArray(list)) { return list; }
    return list.filter(
      (x: any) => x?.itemId !== CandidateJobDetailsComponent.INTERVIEW_REJECTED_ID);
  }

  /**
   * L1/L2/L3 Interview are only reachable once the candidate owner has ACCEPTED the
   * interview invite — see CandidateService.DIRECT_APPLY_OWNER_NEXT, which grants
   * L1/L2/L3_INTERVIEW only from INTERVIEW_ACCEPTED and from L1/L2/L3 themselves.
   * The legacy order-based fallback below has no notion of that state machine and
   * would surface them at APPLIED / SHORTLISTED / INTERVIEW-SCHEDULED.
   *
   * Mirrors candidate-card-table-view.component.ts:834-840 and
   * candidate-card.component.ts:944-948, including their tolerance of the three
   * id spellings that appear in listvalue payloads.
   */
  private static readonly INTERVIEW_ACCEPTED_IDS = [
    'INTERVIEW-ACCEPTED', 'INTERVIEW_ACCEPTED', 'INTERVIEW ACCEPTED'];

  private static readonly L1_L2_L3_IDS = [
    'L1-INTERVIEW', 'L1_INTERVIEW', 'L1 INTERVIEW',
    'L2-INTERVIEW', 'L2_INTERVIEW', 'L2 INTERVIEW',
    'L3-INTERVIEW', 'L3_INTERVIEW', 'L3 INTERVIEW'];

  private withoutEarlyInterviewLevels(list: Array<any>, currentStatus: any): Array<any> {
    if (!Array.isArray(list)) { return list; }
    const C = CandidateJobDetailsComponent;
    const reached = C.INTERVIEW_ACCEPTED_IDS.includes(currentStatus)
      || C.L1_L2_L3_IDS.includes(currentStatus);
    if (reached) { return list; }
    return list.filter((x: any) => !C.L1_L2_L3_IDS.includes(x?.itemId));
  }

  isWait: boolean = false;
  filterApplicant(data: any, nextAllowedStatuses?: string[]) {
    // Backend role guard — empty array means view-only.
    if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length === 0) {
      return [];
    }
    this.isWait = false;
    const arrs: Array<any> = [...this.jobApplicationFilter];

    const order = arrs.find(_x => _x.itemId === data)!.order;

    //  for RECRUITER ACTION
    if (this.contentType === "CDI") {

      // Backend's nextAllowedStatuses is the authoritative state machine
      // (CandidateService.DIRECT_APPLY_OWNER_NEXT / firstUpstreamAllowed). Use it
      // directly so the dropdown shows every status the backend will accept —
      // including INTERVIEW-REJECTED at INTERVIEW-ACCEPTED. Skips the legacy
      // order/wait-flow logic below which would otherwise drop valid options.
      console.log('[filterApplicant-DEBUG candidate-job-details] currentStatus:', data,
          'nextAllowedStatuses:', nextAllowedStatuses,
          'arrs.itemIds:', arrs.map((x: any) => x.itemId));
      if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length > 0) {
        const result = this.withoutEarlyInterviewLevels(
          this.withoutInterviewRejected(
            arrs.filter((_x: any) => nextAllowedStatuses.includes(_x.itemId))),
          data);
        console.log('[filterApplicant-DEBUG candidate-job-details] BACKEND-DRIVEN result:', result.map((x: any) => x.itemId));
        return result;
      }
      console.log('[filterApplicant-DEBUG candidate-job-details] FALLBACK to legacy order-based logic');

      const lastValue: Array<any> = [];
      //  for RECRUITER ACTION

      const finalData: Array<any> = arrs.reduce((acc: Array<any>, current, index, arr) => {

        const isAllWait = arr.some(pp => pp.wait === true);

        const find = acc.find(_d => _d.itemId === current.itemId);
        const next = arr.indexOf(current);
        const offer = arr.filter(o => (o.order === undefined || o.order === null));

        if (find === undefined) {

          const nextData = arr[next + 1];

          if (nextData && current.item != null && data === current.itemId) {
            if ((nextData.item === undefined || nextData.item === null)) {
              //  current.wait = true;
              this.isWait = true;
              return acc;
            }
            else if (nextData.item != undefined || nextData.item != null) {
              this.isWait = false;
              // arr.forEach(p=> p.wait = false);
              return acc;
            }
          }

          if (current && current.item != undefined && current.order != undefined) {
            acc.push(current);
          }
          else if (!lastValue.includes(offer) && (current.order === undefined || current.order === null)) {
            lastValue.push(...offer);
          }

          if (this.isWait) {
            acc = [];
            if (!acc.includes(offer)) {
              acc.push(...offer);
            }
          }
        }

        return acc;
      }, []);

      let final = finalData.filter(_x => _x.order > order);
      if (!this.isWait) {
        final.push(...lastValue);
      }

      // Role-based intersection: keep only statuses the backend says the viewer may set.
      let roleFiltered: Array<any> | null = null;
      if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length > 0) {
        final = final.filter(_x => nextAllowedStatuses.includes(_x.itemId));
        roleFiltered = finalData.filter((_x: any) => nextAllowedStatuses.includes(_x.itemId));
      }

      // Once a candidate has reached the offer stage, "Withdraw Offer" must
      // remain available even if backend role guards (or order-based filtering)
      // would otherwise drop it. Reinstate it for OFFERED and any post-offer stage.
      const offerOrAbove = ['OFFERED', 'OFFER-ACCEPTED', 'PRE-ONBOARDED', 'PREONBOARDED'];
      if (offerOrAbove.includes(data)) {
        const withdrawItem = arrs.find((x: any) => x.itemId === 'OFFER-WITHDRAWN')
          || { itemId: 'OFFER-WITHDRAWN', item: 'Withdraw Offer', value: 'Withdraw Offer' };
        if (!final.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          final.push(withdrawItem);
        }
        if (roleFiltered && !roleFiltered.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          roleFiltered.push(withdrawItem);
        }
        if (!finalData.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          finalData.push(withdrawItem);
        }
      }

      if (roleFiltered) {
        return this.withoutEarlyInterviewLevels(
          this.withoutInterviewRejected(this.isWait ? roleFiltered : final), data);
      }

      return this.withoutEarlyInterviewLevels(
        this.withoutInterviewRejected(this.isWait ? finalData : final), data);

    }  //  for BENCH SALE ACTION
    else if (this.contentType === "JA") {

      const finalData = arrs.reduce((acc: Array<any>, current, index, arr) => {

        const find = acc.find(_d => _d.itemId === current.itemId);
        const next = arr.indexOf(current) + 1;

        if (find === undefined) {

          const nextData = arr[next];

          if (nextData && (current.item === undefined || current.item === null) && data === current.itemId) {
            if (nextData.item != undefined || nextData.item != null) {
              acc.push(...arr.filter(c => c.order === order + 1));
              return acc;
            }
          }

          if ((current.order === undefined || current.order === null) && current.item != undefined) {
            acc.push(current);
          }

        }

        return acc;

      }, []);

      return finalData;
    }

  }

  getFilterValue(key: string) {
    const arrs: Array<any> = [...this.jobApplicationFilter];

    if (arrs) {
      const find = arrs.find(c => c.itemId === key);
      // Fall back to the normalized raw status so unmapped stages
      // (L1/L2/L3 INTERVIEW) never leave the pill blank.
      return find ? find.value : this.formatStatusLabel(key);
    }
  }

  getClass(data) {
    return data.item.split(",")[1];
  }


  negativeStatuses = ['REJECTED','PROFILE-REJECTED','INTERVIEW-REJECTED','INTERVIEW-FAILED','OFFER-DECLINED','CANDIDATE-WITHDRAWN','OFFER-WITHDRAWN'];

  validateNegativeStatus(datas: any, value: any, interviewPayrateTemplate?: TemplateRef<any>) {
    const targetStatus = datas.itemId;
    const currentStatus = value.currentStatus;
    const preInterviewStatuses = ['APPLIED', 'JOB-APPLIED', 'SHORTLISTED', 'CANDIDATE-SHORTLISTED'];
    const isInterviewScheduled = targetStatus === 'INTERVIEW-SCHEDULED'
      || targetStatus === 'INTERVIEW_SCHEDULE'
      || targetStatus === 'INTERVIEW SCHEDULED';
    // Locked 2026-06-08 — bypass list reduced to OFFERED only. SELECTED /
    // CANDIDATE-SELECTED used to open the payrate modal on a pre-interview→
    // SELECTED jump; per owner direction the rate is now anchored to OFFERED.
    const isBypassingInterview = preInterviewStatuses.includes(currentStatus)
      && ['OFFERED'].includes(targetStatus);
    // Validate-only stages — call /validate-b2b-connection to surface the
    // FREE-plan job-owner block (10006) without opening the PayRate modal.
    // Locked 2026-06-08 — OFFER-ACCEPTED removed from this list. Accepting an
    // offer is the candidate-owner confirming the candidate wants the role;
    // it does NOT require a live B2B connection between candidate-owner and
    // job-owner. The B2B link is enforced LATER — at PRE-ONBOARDED / ONBOARDED
    // (when the contract goes live) and at /assign (Initiate Contract wizard).
    // Previously the popup blocked Accept entirely on /newcandidates Applied tab.
    const VALIDATE_STAGES = [
      'INTERVIEW-SCHEDULED',
      'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW',
      'PRE-ONBOARDED', 'PREONBOARDED',
      'ONBOARDED'
    ];
    const isValidateStage = VALIDATE_STAGES.includes(targetStatus);

    if (isInterviewScheduled || isBypassingInterview) {
      const membershipType = localStorage.getItem('MemberShipType');
      if (membershipType === 'Free') {
        // FREE-plan job owner — call validate (no modal) so the backend
        // 10006 gate fires and shows the "Purchase Plan" popup.
        this.validateB2bAndOpenPayrate(datas, value, null);
        return;
      }
      if (interviewPayrateTemplate) {
        this.validateB2bAndOpenPayrate(datas, value, interviewPayrateTemplate);
        return;
      }
    }

    // Hiring-advance stages outside the modal path (L1/L2/L3, OFFER-ACCEPTED,
    // PRE-ONBOARDED, ONBOARDED) — call validate-only so 10006 surfaces.
    if (isValidateStage && !isInterviewScheduled) {
      this.validateB2bAndOpenPayrate(datas, value, null);
      return;
    }

    if (this.negativeStatuses.includes(datas.itemId)) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons.fire({
        title: 'Are you sure you want to ' + this.prepareMessage(datas.itemId) + '?',
        html: `Once you ${this.prepareMessage(datas.itemId)}, the candidate will no longer be considered for this job.<br>
        <p>This action cannot be undone.</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then(result => {
        if (result.isConfirmed) {
          this.updatestatus(datas, value);
        }
      });
    } else {
      this.updatestatus(datas, value);
    }
  }

  prepareMessage(sts: any): string {
    if (sts == 'INTERVIEW-FAILED') {
      return 'reject interview';
    } else if (sts == 'OFFER-WITHDRAWN') {
      return 'withdraw offer';
    } else if (sts == 'PROFILE-REJECTED') {
      return 'reject profile';
    } else if (sts == 'CANDIDATE-WITHDRAWN') {
      return 'withdraw';
    } else if (sts == 'OFFER-DECLINED') {
      return 'decline offer';
    }
  }

  isPayrateReadonly: boolean = false;

  private validateB2bAndOpenPayrate(datas: any, value: any, template: TemplateRef<any>): void {
    const userId = localStorage.getItem('userId') || '';
    const targetStatus = datas?.itemId || '';
    this.util.startLoader();
    this.api.query(`business/findUserRoleInBusiness/${userId}`).subscribe({
      next: (res: any) => {
        const businessId = res?.data?.businessData?.businessId;
        if (!businessId) {
          this.util.stopLoader();
          Swal.fire({ icon: 'warning', title: 'Business not found', text: 'Unable to determine your business. Please try again.', showConfirmButton: true });
          return;
        }
        const candidateId = value?.candidateEntity?.candidateId || value?.candidateId || '';
        const jobId = value?.jobDetails?.jobId || '';
        this.contractCandidateService.validateB2bConnection(businessId, jobId, candidateId, targetStatus).subscribe({
          next: (b2bRes: any) => {
            this.util.stopLoader();
            if (b2bRes?.code === '00000') {
              // Validate-only path (no template) — proceed without opening the modal.
              if (b2bRes.data?.skipContractCreation || !template) {
                this.updatestatus(datas, value);
                return;
              }
              this.b2bData = b2bRes.data;
              this.openInterviewPayrateModal(datas, value, template);
            } else if (b2bRes?.code === '99996') {
              // Mandatory-document gate — shared wording with candidate-card so
              // the same blocker never reads two different ways.
              this.contractCandidateService.showMandatoryDocumentPopup();
            } else if (b2bRes?.code === '10004') {
              Swal.fire({
                icon: 'warning',
                title: 'Business Plan Required',
                html: b2bRes.message || 'Please purchase a business plan to proceed with the next process.',
                confirmButtonText: 'OK',
                showCancelButton: false
              });
            } else if (b2bRes?.code === '10006') {
              // FREE-plan job owner trying to advance to INTERVIEW-SCHEDULED or above —
              // block with the "Purchase Plan" popup and abort the status change.
              Swal.fire({
                icon: 'warning',
                title: 'Plan Required',
                html: b2bRes.message || 'You need to purchase a plan to hire the candidate.',
                confirmButtonText: 'OK',
                showCancelButton: false
              });
            } else if (b2bRes?.code === '10001') {
              Swal.fire({
                icon: 'warning',
                title: 'Candidate Not Linked to a Business',
                text: 'This candidate must be associated with a business before a contract can be created.',
                confirmButtonText: 'OK'
              });
            } else if (b2bRes?.code === '10002') {
              const supplierBusinessId = b2bRes.data?.supplierBusinessId || '';
              Swal.fire({
                icon: 'warning',
                title: 'Business Connection Required',
                text: 'You need to establish a business connection before moving this candidate to the next stage. Would you like to go to Business Contacts to set up the connection?',
                showCancelButton: true,
                confirmButtonText: 'Yes, Go to Business Contacts',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#8B5CF6',
                cancelButtonColor: '#6c757d',
                reverseButtons: true
              }).then(result => {
                if (result.isConfirmed) {
                  this.router.navigate(['/user-management/businessContacts'], {
                    queryParams: supplierBusinessId ? { supplierBusinessId } : {}
                  });
                }
              });
            } else if (b2bRes?.code === '10003') {
              Swal.fire({
                icon: 'warning',
                title: 'Business Connection Required',
                text: 'Contact Super Admin to initiate business connection with supplier.',
                confirmButtonText: 'OK'
              });
            } else {
              Swal.fire({ icon: 'error', title: 'Validation Failed', text: b2bRes?.message || 'B2B connection validation failed.', showConfirmButton: true });
            }
          },
          error: () => {
            this.util.stopLoader();
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to validate B2B connection.', showConfirmButton: true });
          }
        });
      },
      error: () => {
        this.util.stopLoader();
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch business details.', showConfirmButton: true });
      }
    });
  }

  /**
   * Locked 2026-06-08 — tier resolver (parity with candidate-card.resolveViewerTier).
   *   1. Tier where viewer is customerBusinessId
   *   2. Fallback: tier where viewer is supplierBusinessId (immediate-upstream)
   *   3. Locked 2026-06-10 — final fallback REMOVED. If no tier matches the viewer's
   *      customer / supplier IDs, return null and let patchPayrateCeiling pick up
   *      JobDetails.targetRateTo + payType. Previously fell through to tiers[0]
   *      which silently used the job-owner's tier as the "Submitted for" ceiling
   *      for every viewer — wrong when the tier array doesn't cover the viewer.
   */
  private resolveViewerTier(viewerBizId: string, job: any): any {
    const tiers = job?.tierPayRates || [];
    if (!tiers.length || !viewerBizId) return null;
    const owned = tiers.find((t: any) => t?.customerBusinessId
        && t.customerBusinessId.toLowerCase() === viewerBizId.toLowerCase());
    if (owned) return owned;
    const upstream = tiers.find((t: any) => t?.supplierBusinessId
        && t.supplierBusinessId.toLowerCase() === viewerBizId.toLowerCase());
    if (upstream) return upstream;
    return null;
  }

  private patchPayrateCeiling(value: any): void {
    const viewerBizId = localStorage.getItem('myBusinessId')
        || localStorage.getItem('businessId') || '';
    const job = value?.jobDetails;
    const tier = this.resolveViewerTier(viewerBizId, job);
    // Locked 2026-06-10 — fallback when tierPayRates has no row for this
    // (customerBusinessId, supplierBusinessId) pair: read the ceiling from the
    // JobDetails table directly (targetRateTo + payType). Two-tier read:
    //   tier match (per-supplier ceiling) > JobDetails.targetRateTo (job-level ceiling)
    const submittedToRate = tier?.toPayRate ?? job?.targetRateTo ?? null;
    const submittedRateType = tier?.rateType ?? job?.payType ?? 'Hourly';
    // Locked 2026-06-10 — Offer For initial value mirrors Submitted For. The user
    // can edit Offer For (it's the editable row); Submitted For stays read-only.
    // Previously Offer For defaulted to the candidate's existing targetRate, which
    // for a fresh OFFERED transition was usually null — leaving the field blank.
    // Now both rows pre-fill with the same tier (or JobDetails fallback) value,
    // and the user adjusts Offer For from there.
    this.rtrformgrp.patchValue({
      submittedToRate,
      submittedRateType,
      offerRate: submittedToRate,
      offerRateType: submittedRateType,
      country: value?.candidateEntity?.country || '',
      termsandcondition: null
    });
    const offerCtrl = this.rtrformgrp.get('offerRate');
    if (offerCtrl) {
      const validators = [Validators.required, CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace()];
      if (typeof submittedToRate === 'number' && submittedToRate > 0) {
        validators.push(Validators.max(submittedToRate));
      }
      offerCtrl.setValidators(validators);
      offerCtrl.updateValueAndValidity({ emitEvent: false });
    }
  }

  openInterviewPayrateModal(datas: any, value: any, template: TemplateRef<any>): void {
    console.log('openInterviewPayrateModal - candidate details:', value);
    console.log('openInterviewPayrateModal - job details:', value.jobDetails);
    this.pendingOfferedData = datas;
    this.pendingOfferedCandidate = value;
    this.submitRTR = false;
    this.rtrformgrp.reset();
    this.patchPayrateCeiling(value);

    const modalOptions: ModalOptions = { class: 'modal-md', backdrop: 'static', keyboard: false };
    this.rtrModalRef = this.modalService.show(template, modalOptions);
  }

  openPayrateModal(datas: any, value: any, template: TemplateRef<any>): void {
    this.pendingOfferedData = datas;
    this.pendingOfferedCandidate = value;
    this.submitRTR = false;
    this.rtrformgrp.reset();
    this.patchPayrateCeiling(value);
    const modalOptions: ModalOptions = { class: 'modal-md', backdrop: 'static', keyboard: false };
    this.rtrModalRef = this.modalService.show(template, modalOptions);
  }

  submitPayrate(): void {
    this.submitRTR = true;
    if (this.rtrformgrp.invalid) return;

    // Locked 2026-06-08 — UI uses offerRate/offerRateType; wire stays targetRate/payType.
    const payload = {
      jobId: this.pendingOfferedCandidate.jobDetails.jobId,
      candidateId: this.pendingOfferedCandidate.candidateEntity.candidateId,
      candidateStatus: this.pendingOfferedData.itemId,
      createdBy: this.userId,
      targetRate: parseFloat(this.rtrformgrp.value.offerRate),
      payType: this.rtrformgrp.value.offerRateType,
      customerBusinessId: this.b2bData?.customerBusinessId || '',
      supplierBusinessId: this.b2bData?.supplierBusinessId || '',
      b2bContactId: this.b2bData?.b2bContactId || '',
      isSubContracted: this.b2bData?.subContracted || false
    };

    this.util.startLoader();
    this.contractCandidateService.createCandidate(payload).subscribe({
      next: (res) => {
        if (res.code === '00000') {
          const offeredData = this.pendingOfferedData;
          const offeredCandidate = this.pendingOfferedCandidate;
          this.hidePayrateModal();
          this.updatestatus(offeredData, offeredCandidate);
        } else if (res.code === '00001') {
          this.util.stopLoader();
          this.hidePayrateModal();
          Swal.fire({
            title: 'Business Connection Required',
            text: 'You need to establish a business connection before moving this candidate to the next stage. Would you like to go to Business Contacts to set up the connection?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Go to Business Contacts',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#8B5CF6',
            cancelButtonColor: '#6c757d'
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/user-management/businessContacts']);
            }
          });
        } else if (res.code === '10001') {
          this.util.stopLoader();
          this.hidePayrateModal();
          Swal.fire({
            icon: 'warning',
            title: 'Candidate Not Linked to a Business',
            text: 'This candidate must be associated with a business before a contract can be created.',
            confirmButtonText: 'OK'
          });
        } else if (res.code === '10002') {
          this.util.stopLoader();
          this.hidePayrateModal();
          const supplierBusinessId = res.data?.supplierBusinessId || '';
          Swal.fire({
            title: 'No B2B Connection Found',
            text: 'These two businesses are not connected. Would you like to go to Business Contacts to establish the connection?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Go to Business Contacts',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#8B5CF6',
            cancelButtonColor: '#6c757d'
          }).then(result => {
            if (result.isConfirmed) {
              this.router.navigate(['/user-management/businessContacts'], {
                queryParams: supplierBusinessId ? { supplierBusinessId } : {}
              });
            }
          });
        } else {
          this.util.stopLoader();
          Swal.fire('Error', res.message || 'Failed to create contract candidate', 'error');
        }
      },
      error: (err) => {
        this.util.stopLoader();
        Swal.fire('Error', 'Failed to create contract candidate', 'error');
      }
    });
  }

  hidePayrateModal(): void {
    if (this.rtrModalRef) {
      this.rtrModalRef.hide();
    }
    setTimeout(() => {
      this.rtrformgrp.reset();
      this.submitRTR = false;
      this.pendingOfferedData = null;
      this.pendingOfferedCandidate = null;
    }, 1000);
  }

  updatestatus(datas, value) {
    this.util.startLoader();
    var data: any = {};
    data.jobId = value.jobDetails.jobId;
    data.candidateId = value.candidateEntity.candidateId;
    data.currentStatus = datas.itemId;
    data.candidateName = value.candidateEntity.firstName + " " + value.candidateEntity.lastName;
    data.jobTitle = value.jobDetails.jobTitle;
    data.createdByUserName = value.jobDetails.postedByUserName;
    data.email = value.user.email;
    var dropId = document.getElementById("jb_dpDown");
    dropId.classList.remove("open");
    this.api.create("candidates/updatejobAppliedStatus", data).subscribe(
      (res) => {
        this.util.stopLoader();
        if (res.code == "00000") {
          this.interactionResponse.forEach((element) => {
            if (
              value.candidateEntity.candidateId ==
              element.candidateEntity.candidateId &&
              value.jobDetails.jobId == element.jobDetails.jobId
            ) {
              element.currentStatus = datas.itemId;
            }
          });

          Swal.fire({
            position: "center",
            icon: "success",
            title: "Status successfully Updated.",
            showConfirmButton: false,
            timer: 2000,
          });
        } else if (res.code == "99998") {
          Swal.fire({
            position: "center",
            icon: "info",
            title: "Job application status updated already..!",
            showConfirmButton: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              this.JobServicecolor.confirmResult();
            }
          });
        } else if(res.code =='99996'){
          // Same mandatory-document gate as validate-b2b-connection — one
          // wording for both paths so the user never sees two different
          // sentences for the same blocker.
          this.contractCandidateService.showMandatoryDocumentPopup();
        }
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  chatuser(seletedItem) {
    this.messagemodelflag = false;

    if (seletedItem.jobPostedBy == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }

    setTimeout(() => {
      seletedItem.userId = seletedItem.jobPostedBy;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "JOB";
      seletedItem.messageType = "JOB";
      seletedItem.id = seletedItem.jobId;
      this.messageData = seletedItem;
    }, 1000);
  }
  shouldShowStatusText(data: any): boolean {
    return (
      this.contentType !== 'JA' && (
        data?.candidateEntity?.status === 'INACTIVE' ||
        data?.candidateEntity?.status === 'BLOCKED' ||
        !data?.candidateEntity?.availability
      )
    );
  }

  getStatusText(data: any): string {
    return data?.candidateEntity?.status === 'BLOCKED' ? 'Blocked' : 'Unavailable';
  }
  CIshouldShowStatusText(data: any): boolean {
    return data?.candidateEntity?.status === 'INACTIVE' ||
      data?.candidateEntity?.status === 'BLOCKED' ||
      !data?.candidateEntity?.availability;
  }

  chatusercandidate(seletedItem) {
    if (seletedItem.status != 'ON HOLD' && seletedItem.availability) {
      this.messagemodelflag = false;
      if (seletedItem.createdBy == this.userId) {
        seletedItem.owner = true;
      } else {
        seletedItem.owner = false;
      }
      setTimeout(() => {
        seletedItem.userId = seletedItem.createdBy;
        this.seletedChatItem = seletedItem;
        this.messageData = [];
        this.messagemodelflag = true;
        seletedItem.groupType = "CANDIDATE";
        seletedItem.messageType = "CANDIDATE";
        seletedItem.id = seletedItem.candidateId;
        this.messageData = seletedItem;
      }, 1000);
    }
  }
  async openMessagecheckInteraction(seletedItem, connectionTemplate?: TemplateRef<any>) {
    // Universal first-interaction: skip the ACTIVE_INTERACTIONS gate (no
    // findUserPlanBenefits / findPlans) when this interaction was already consumed.
    // This is a CANDIDATE chat, so the backend `alreadyConsumed` flag covers an
    // existing chat OR a prior invite / resume-request. The Applied menu is the one
    // case the candidate-chat check can't see (its consume is a job-side apply), so
    // that container still flags it directly via skipInteractionGate.
    // Owner's rule (2026-09-09): one credit is consumed only when a chat is
    // first initiated, so every menu (Eye-icon widgets, Active Interactions,
    // job tabs) follows this exist-first order before any slot check.
    if (this.skipInteractionGate ||
        await this.pricePlan.isInteractionAlreadyConsumed(seletedItem?.candidateId, 'CANDIDATE')) {
      this.chatusercandidate(seletedItem);
      return;
    }
    // Existing conversation → the credit was already spent when it was first
    // initiated; reopening/continuing must not re-consume a credit (parity
    // with the /message page). Existing threads open free.
    if ((seletedItem?.chatHistoryCount || 0) > 0) {
      this.chatusercandidate(seletedItem);
      return;
    }
    // Own candidate with no existing thread → nothing to open: owners never
    // initiate a chat (they only respond). Mirrors the card's owner +
    // no-history placeholder state.
    if (seletedItem?.createdBy == this.userId) {
      return;
    }
    try {
      this.util.startLoader();
      const userData = await this.pricePlan.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.util.startLoader();
        this.chatusercandidate(seletedItem);

        return;
      }

      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.pricePlan.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

      } else {
        this.util.startLoader();
        this.chatusercandidate(seletedItem);

      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      }, 1500);
    }

  }

  disableCard(data: any): boolean {
    return (
      (data.candidateEntity && data.candidateEntity.status !== "ACTIVE") ||
      (data.candidateEntity && !data.candidateEntity.availability) ||
      (data.jobDetails != undefined && data.jobDetails.status !== "ACTIVE") ||
      (data.jobDetails != undefined && !data.jobDetails.availability)
    );
  }

  trackByCode(index: number, data: any): string {
    return this.contentType === "JA"
      ? data.candidateEntity.candidateId
      : data.jobDetails.jobId;
  }

  private getCardId(data: any): string {
    const candidateId = data?.candidateEntity?.candidateId || data?.candidateId || '';
    const jobId = data?.jobDetails?.jobId || data?.jobId || '';

    // A candidate can be invited to multiple jobs, so neither ID is unique alone.
    return `${candidateId}:${jobId}`;
  }

toggleSkills(data: any, event: Event) {
  event.stopPropagation(); // prevent triggering the card's (click)="route(...)"
  const id = this.getCardId(data);
  if (this.expandedSkills.has(id)) {
    this.expandedSkills.delete(id);
  } else {
    this.expandedSkills.add(id);
  }
}

isSkillsExpanded(data: any): boolean {
  return this.expandedSkills.has(this.getCardId(data));
}

getVisibleSkills(data: any): string[] {
  const allSkills: string[] = this.getData(data, 'primarySkills') || [];
  return this.isSkillsExpanded(data) ? allSkills : allSkills.slice(0, 3);
}

  pagecount(event) {
    this.page = event;
    this.nextPage.emit(event);
  }

  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('Files browsed:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }
  fileDragdrop: any = null;
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }
  
    const file = files[0]; // Get the first file
    console.log('Processing file:', file);
  
    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }
  
    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];
  
    console.log('File type:', file.type);
  
    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type)) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;

      // If there's a tempdata and candidateEntity, update the resumeAttached property
      if (this.tempdata && this.tempdata.candidateEntity) {
        this.tempdata.candidateEntity.resumeAttached = true;
      }

      // Trigger change detection if needed
      if (this.cdr && !this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      if (this.fileDropRef?.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }

  removeFiles() {
    this.fileDragdrop = null;
    this.resumeupload = null;
    
    // Reset resumeAttached flag in tempdata if it exists
    if (this.tempdata && this.tempdata.candidateEntity) {
      this.tempdata.candidateEntity.resumeAttached = false;
    }
    
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
    
    // Trigger change detection if needed
    if (this.cdr && !this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  checkAttached() {
    // First check if the candidate already has a resume attached
    if (this.tempdata && this.tempdata.candidateEntity && 
        this.tempdata.candidateEntity.resumeAttached === true) {
      return false; // Already has resume, so return false (not needed to attach)
    }
    
    // Then check if a new resume has been uploaded
    if (this.resumeupload === "" || 
        this.resumeupload === undefined || 
        this.resumeupload === null) {
      return true; // No resume, so return true (yes, attachment needed)
    } else {
      return false; // Has new resume, so return false (not needed to attach)
    }
  }

  submit() {
    this.rtrformgrp.markAllAsTouched();
    this.submitRTR = true;
    var data: any = {};
    if (
      !this.tempdata.candidateEntity.resumeAttached &&
      this.checkAttached() &&
      this.statusCall !== "REJECTED"
    ) {
      Swal.fire({
        icon: "info",
        title: "Please Upload Resume...",
        showDenyButton: false,
        timer: 3000,
      });
      return;
    }

    if (
      (this.rtrformgrp.valid && this.rtrformgrp.value.termsandcondition) ||
      this.statusCall === "REJECTED"
    ) {
      this.util.startLoader();
      data.jobId = this.tempdata.jobDetails.jobId;
      data.organisationName = this.tempdata.user.organisation;
      data.postedByUserName = this.tempdata.jobDetails.postedByUserName;
      data.jobTitle = this.tempdata.jobDetails.jobTitle;
      // data.email=this.tempdata.user.email
      data.jobPostedBy = this.tempdata.jobDetails.jobPostedBy;
      data.candidateId = this.tempdata.candidateEntity.candidateId;
      data.currentStatus = this.tempstatus;
      data.targetRateFortheCandidate = this.rtrformgrp.value.targetrate;
      data.payTypeFortheCandidate = this.rtrformgrp.value.RtrpayType;
      // data.primaryResume=true;

      var dropId = document.getElementById("jb_dpDown");
      
      const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
      if (this.resumeupload && this.resumeupload.size > MAX_FILE_SIZE) {
        Swal.fire("", `${this.IMAGE_ERROR}`, "info");
        this.util.stopLoader();
        return;
      }     

      this.FormData = new FormData();
      this.FormData.append(
        "job",
        new Blob([JSON.stringify(data)], { type: "application/json" })
      );
      this.FormData.append("file", this.resumeupload);

      this.api
        .create("jobs/updateInterestShownStatus", this.FormData)
        .subscribe(
          (res) => {
            this.util.stopLoader();
            if (res.code == "00000") {
              this.jobsApi();
              if (this.statusCall === "ACCEPTED") this.hide();
              Swal.fire({
                icon: "success",
                title: `Invitation ${this.statusCall === "ACCEPTED" ? "Accepted" : "Rejected"
                  } Sucessfully`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.resumeupload = "";
              this.fileDragdrop = "";
              if (this.fileDropRef?.nativeElement) {
                this.fileDropRef.nativeElement.value = '';
              }
            }
          },
          (err) => {
            this.util.stopLoader();
            console.log('error ::: ', err);
            // 🔴 Handle file size error
            if (err?.status === 413) {
              Swal.fire({
                icon: "error",
                title: "File too large",
                text: "File size is above 10 MB. Please upload a smaller file.",
                confirmButtonText: "OK",
              });
            }
          }
        );
    }
  }

  jobsApi() {
    this.util.startLoader();
    this.api
      .create("candidates/findMyCandidatesInvitations", this.obj)
      .subscribe((res) => {
        this.util.stopLoader();
        if (res.data != null) {
          res.data.candidateInvitations.forEach((ele) => {
            if (ele.user != null) {
              if (ele.user != null && ele.user.photo != null) {
                ele.user.photo = AppSettings.photoUrl + ele.user.photo;
              } else if (ele.user != null && ele.user.photo == null) {
                ele.user.photo = null;
              }
            }
          });
          this.interactionResponse = res.data.candidateInvitations;
        }
      });
  }
  async updatestatusFor(status, value, rtrtemplate: TemplateRef<any>) {
    try {
      if (status === "ACCEPTED") {
        let userData = await this.pricePlan.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");

        // Check if userDetail and userPlanAndBenefits are available before accessing
        if (userData.userDetail && userData.userDetail.userPlanAndBenefits) {
          let { membershipType } = userData;
          let availablePoints = null;
          let actualPoints = null;
          let utilizedPoints = null;
          let promotional = null;

          if (value.candidateEntity.resumeAttached) {
            this.showResumeUpload = false;
          } else {
            this.showResumeUpload = true;
          }

          userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach((ele) => {
            if (ele.benefitKey == "ACTIVE_INTERACTIONS") {
              availablePoints = ele.available;
              actualPoints = ele.actual;
              utilizedPoints = ele.utilized;
              promotional = ele.promotional;
            }
          });

          if (userData.isExpired) {
            let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

            if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
              popupType = "LIMIT";
            }

            this.pricePlan.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
          } else {
            this.afterValidatingPlan(status, value, rtrtemplate);
          }
        } else {
          this.afterValidatingPlan(status, value, rtrtemplate);
        }
      } else {
        this.afterValidatingPlan(status, value, rtrtemplate);
      }
    } catch (error) {

    }
  }


  afterValidatingPlan(status, value, rtrtemplate: TemplateRef<any>) {
    this.tempstatus = status;
    this.rtrformgrp.patchValue({
      RtrpayType:
        value.jobDetails.payType != null ? value.jobDetails.payType : "Hourly",
      targetrate: value.jobDetails.targetRateTo,
      country: value.jobDetails.country != null ? value.jobDetails.country : "",
      termsandcondition: null,
    });
    this.rtrformgrp.get("termsandcondition").markAsUntouched();

    this.util.startLoader();
    if (status === "ACCEPTED") {
      this.statusCall = "ACCEPTED";
      if (
        value.candidateEntity.resumes != null ||
        value.candidateEntity.resumes != undefined
      ) {
        this.showResumeUpload =
          value.candidateEntity.resumes.length > 0 ? false : true;

        let ngbModalOptions: NgbModalOptions = {
          backdrop: "static",
          keyboard: false,
        };
        this.tempdata = value;
        this.resumeupload = "";
        this.fileDragdrop = "";
        if (this.fileDropRef?.nativeElement) {
          this.fileDropRef.nativeElement.value = '';
        }
        this.modalRef = this.modalService.show(rtrtemplate, ngbModalOptions);
        this.util.stopLoader();
      } else if (
        value.candidateEntity.resumes === undefined ||
        value.candidateEntity.resumes === null
      ) {
        this.showResumeUpload = true;

        let ngbModalOptions: NgbModalOptions = {
          backdrop: "static",
          keyboard: false,
        };
        this.tempdata = value;
        this.resumeupload = "";
        this.fileDragdrop = "";
        if (this.fileDropRef?.nativeElement) {
          this.fileDropRef.nativeElement.value = '';
        }
        this.modalRef = this.modalService.show(rtrtemplate, ngbModalOptions);
        this.util.stopLoader();
      }
    } else if (status === "REJECTED") {
      this.statusCall = "REJECTED";
      this.tempdata = value;
      this.resumeupload = "";
      this.fileDragdrop = "";
      if (this.fileDropRef?.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      this.submit();
    }
    this.util.stopLoader();
  }

  submitResume() {
    let data: any = {};
    data.candidateId = this.candidateId;
    data.userId = this.resumeuploaduserId;
    data.jobId = this.jobId;

    if (
      this.resumeupload != undefined &&
      this.resumeupload != null &&
      this.resumeupload != ""
    ) {
      this.FormData = new FormData();
      this.FormData.append("resume", this.resumeupload);
      this.FormData.append(
        "candidate",
        new Blob([JSON.stringify(data)], { type: "application/json" })
      );
      this.resumeupload = "";
      this.util.startLoader();
      this.api
        .updatePut("candidates/updateResumeRequestStatus", this.FormData)
        .subscribe((res) => {
          this.modalRef.hide();
          this.util.stopLoader();
          if (res.code == "00000") {
            this.modalRef.hide();
            this.interactionResponse.forEach((element, i) => {
              if (this.candidateId == element.candidateEntity.candidateId) {
                element.currentStatus = "COMPLETED";
              }
            });
            this.interactionResponse = [...this.interactionResponse];

            Swal.fire({
              position: "center",
              icon: "success",
              title: "Resumes Attached successfully",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        });
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please select file",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }

  model(items, template: TemplateRef<any>, index) {
    this.util.startLoader();
    this.resumeupload = null;
    this.fileDragdrop = null;
    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
    this.resumeIndex = index;
    this.tempdata = items; // Store reference to current data item for prepareFilesList() and hideResumeModal()
    this.candidateId = items.candidateEntity.candidateId;
    if (items.jobDetails != null) {
      this.jobId = items.jobDetails.jobId;
      this.resumeuploaduserId = items.jobDetails.jobPostedBy;
    }
    let ngbModalOptions: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
    };
    let resume: Array<any> = items.candidateEntity.resumes;
    if (!resume || resume.length === 0) {
      this.util.stopLoader();
      this.modalRef = this.modalService.show(template, ngbModalOptions);
      this.util.stopLoader();
    }

  }

  get rtrFormControls() {
    return this.rtrformgrp.controls;
  }

  hide() {
    this.modalRef.hide();
    this.rtrformgrp.reset();
    this.resumeupload = null;
    this.fileDragdrop = null;

    // Reset resumeAttached flag when canceling without submission
    if (this.tempdata && this.tempdata.candidateEntity) {
      this.tempdata.candidateEntity.resumeAttached = false;
    }

    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }

    // Trigger change detection
    if (this.cdr && !this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  hideResumeModal() {
    this.modalRef.hide();
    this.resumeupload = null;
    this.fileDragdrop = null;

    // Reset resumeAttached flag when canceling without submission
    if (this.tempdata && this.tempdata.candidateEntity) {
      this.tempdata.candidateEntity.resumeAttached = false;
    }

    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }

    // Trigger change detection
    if (this.cdr && !this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }

  closeMessage(event) {
    this.messagemodelflag = false;
  }
}

